import { Component, OnDestroy, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as fromCoreStore from "../core/_store";
import { AdministratorModeActions } from '../core/_store';
import * as _ from 'lodash';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})

export class HeaderMenuComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  items: any = []
  storeSubscription$: Subscription;
  isAdminSubscription$: Subscription;
  haveScroll = false;

  constructor(
    private store: Store<fromCoreStore.CoreState>,
    private cdr: ChangeDetectorRef,
    private elRef: ElementRef
  ) {
  }

  loadMenuAdmin() {
    this.store.dispatch(new AdministratorModeActions.LoadMenuAdmin());
  }

  loadMenuRegular() {
    this.store.dispatch(new AdministratorModeActions.LoadMenuRegular());
  }
  ngOnInit() {
    this.isAdminSubscription$ = this.store
    .pipe(select(fromCoreStore.getSelectedIsAdmin))
    .subscribe((data:any) => {
      if (data != undefined) {
        this.isAdmin = data;
        this.cdr.detectChanges();
      } else {
        this.isAdmin = localStorage.getItem("isAdmin") ? true : false;
        this.cdr.detectChanges();
      }
    });

    this.storeSubscription$ = this.store
    .pipe(select(fromCoreStore.getSelectedMenuItems))
    .subscribe((data: any) => {
      if (!data && localStorage.getItem('token')){
        if (this.isAdmin) {
          this.loadMenuAdmin();
        } else {
          this.loadMenuRegular();
        }
      }
      this.items = _.cloneDeep(data);
    });
  }

  /**
   * core only has /#/
   * jul-web has /jul-web/#/
   * @param innerUrl
   */
  buildHrefUrl(innerUrl: string) {
    var baseRef = environment.coreServer;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    var path = innerUrl;

    if (innerUrl.includes("http")){
      return innerUrl;
    }


    if (!path || path && !path.startsWith("/")) {
      path = "/" + path;
    }
    return baseRef + "#" + path;
  }

  ngOnDestroy(): void {
    if(this.storeSubscription$){
      this.storeSubscription$.unsubscribe();
    }
    if(this.isAdminSubscription$){
      this.isAdminSubscription$.unsubscribe();
    }
  }

  top(i){
    var div = document.getElementById('menu-dropdown');
    if (div)
    this.haveScroll = div.scrollHeight > div.clientHeight;

    if (this.elRef.nativeElement.querySelector("#menu" + i)){
      this.items[i].topHeight = (this.elRef.nativeElement.querySelector("#menu" + i) && this.elRef.nativeElement.querySelector("#menu" + i).getBoundingClientRect().y)-47
    }
  }


}
